import { Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import PaymentChannels from "./pages/paymentchannels";
import NotFound from "./pages/notfound";
import FeederInfo from "./pages/feederinfo";
import Customercare from "./pages/customercare";
import Tariff from "./pages/tariff";
import FAQ from "./pages/faq";
import Layout from "./components/layout";
import PPEPolicy from "./pages/ppepolicy";
import DrugAcoholPolicy from "./pages/drugalcoholpolicy";
import OccupationalHealthPolicy from "./pages/occupationalhealthpolicy";
import EnvironmentalPolicy from "./pages/environmentalpolicy";
import CustomerBillRight from "./pages/customerbill";
import RequirementPointLoad from "./pages/requirementpointload";
import Newtariffclassification from "./pages/newtariffclassification";
import CustomerProtection from "./pages/customerprotection";
import Publications from "./pages/publications";
import CorporateCommunications from "./pages/corporatecommunications";
import BandAFeeders from "./pages/bandAfeeders";
import Contact from "./pages/contact";
import Metering from "./pages/metering";
import KCAKuma from "./pages/ksakuma";
import BoardOfDirectors from "./pages/boardofdirectors";
import JonathanLawani from "./pages/jonathanlawani";
import PrivacyPolicy from "./pages/privacypolicy";
import AdminLayout from "./pages/admin/adminlayout";
import AdminDashboard from "./pages/admin/dashboard";
import PostTable from "./pages/admin/posts";
import BandAEmergency from "./pages/bandacustomer";
import AdminUsers from "./pages/admin/users";
import BlogPostDetail from "./components/blogdetail";
import CreatePost from "./pages/admin/newpost";
import MeterPriceList from "./pages/meterpricelist";
import AdminMeterPriceList from "./pages/admin/meterprices";
import MeterPriceView from "./pages/meterpriceview";
import ChangePassword from "./pages/admin/changepassword";
import Careers from "./pages/careers";
import SearchJobs from "./pages/searchjobs";
import AdminJobs from "./pages/admin/jobs";
import JobDetails from "./pages/joddetail";
import MAPMETERREFUNDSLIST from "./pages/map-meter-refund";
import AbayomiAdeyemi from "./pages/abayomi-adeyemi";
import AyodejiGbeleyi from "./pages/ayodeji-gbeleyi.jsx";
import OkaimaOhizua from "./pages/okaima-ohizua.jsx";
import OrderListView from "./pages/orderlistview.jsx";
import MytoOrders from "./pages/admin/mytoorders.jsx";
import FinancialStatement from "./pages/admin/financialstatements.jsx";
import FinancialStatementList from "./pages/financialstatementlist.jsx";
import FeedersReports from "./pages/admin/feederreports.jsx";
import AboutUs from "./pages/about-us-save.jsx";
import Osamwonyi from "./pages/osamwonyi.jsx";

function App() {

  return (
    <Routes>
      {/* LAYOUT ROUTE */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/board-of-directors" element={<BoardOfDirectors />} />
        <Route path="/e-payment-channels" element={<PaymentChannels />} />
        <Route path="/customer-feeder-info" element={<FeederInfo />} />
        <Route path="/customer-care" element={<Customercare />} />
        <Route path="/tariff" element={<Tariff />} />
        <Route path="/faq" element={<FAQ />} />
        {/* <Route path="/e-billing" element={<EBilling />} /> */}
        {/* <Route path="/safety-awards" element={<SafetyAwards />} /> */}
        <Route path="/personal-protective-equipment-ppe-policy" element={<PPEPolicy />} />
        <Route path="/drug-and-policy-control" element={<DrugAcoholPolicy />} />
        <Route path="/occupational-health-and-safety-policy" element={<OccupationalHealthPolicy />} />
        <Route path="/environmental-and-social-policy-statement" element={<EnvironmentalPolicy />} />
        <Route path="/customer-bill-of-rights-and-obligations" element={<CustomerBillRight />} />
        <Route path="/requirement-for-the-connection-of-point-load-transformers" element={<RequirementPointLoad />} />
        <Route path="/bedc-myto-order" element={<OrderListView/>} />
        <Route path="/new-electricity-tariff-and-customer-classification" element={<Newtariffclassification />} />
        <Route path="/customer-protection-regulations-2023-2" element={<CustomerProtection />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/corporate-communications" element={<CorporateCommunications />} />
        <Route path="/metering" element={<Metering />} />
        <Route path="/band-a-feeders" element={<BandAFeeders />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={< AboutUs/>} />
        <Route path="/board-of-directors/kings-c-akuma" element={<KCAKuma />} />
        <Route path="/board-of-directors/osamwonyi-uhunmwangho" element={<Osamwonyi />} />
        <Route path="/board-of-directors/abayomi-Adeyemi" element={<AbayomiAdeyemi/>} />
        <Route path="/board-of-directors/ayodeji-gbeleyi" element={<AyodejiGbeleyi/>} />
        <Route path="/board-of-directors/okaima-ohizua" element={<OkaimaOhizua/>} />
        <Route path="/board-of-directors/engr-jonathan-lawani/" element={<JonathanLawani />} />
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
        <Route path="/band-a-customers-emergency-response-contacts" element={<BandAEmergency />} />
        <Route path="/:postLinkTitle" element={<BlogPostDetail />} />
        {/* <Route path="/category/map-meter-refund" element={<MAPMETERREFUNDSLIST />} /> */}
        <Route path="/category/map-meter-prices" element={<MeterPriceList />} />
        <Route path="/category/bedc-audited-financial-statements" element={<FinancialStatementList />} />
        {/* <Route path="/meter-price" element={<MeterPriceView/>} /> */}
        <Route path="/meter-prices/:postLinkTitle" element={<MeterPriceView />} />
        <Route path="/map-meter-refund" element={<MAPMETERREFUNDSLIST/>} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/search-jobs" element={<SearchJobs />} />
        <Route path="/job/:id" element={<JobDetails />} />
      </Route>

      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/posts" element={<PostTable />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/jobs" element={<AdminJobs />} />
        <Route path="/admin/orders" element={<MytoOrders />} />
        <Route path="/admin/post/new" element={<CreatePost />} />
        <Route path="/admin/meter-price" element={<AdminMeterPriceList />} />
        <Route path="/admin/financial-statement" element={<FinancialStatement/>} />
        <Route path="/admin/feeders-reports" element={<FeedersReports/>} />
        <Route path="/admin/change-password" element={<ChangePassword />} />
        {/* <Route path="/admin/jobs" element={<Jobs />} /> */}
      </Route>

      {/* NOT FOUND */}
      <Route path="*" element={<NotFound />} />
  

    </Routes>
  );
}

export default App;
